// Mapper keys for field identification
export const MAPPER_KEY = {
  SUPER_OPTION: 'superannuation.option',
  SUPER_TYPE: 'superannuation.type',
  SUPER_NAME: 'superannuation.name',
  SUPER_TFN_NUMBER: 'superannuation.tfn.number',
  SUPER_FUND: 'superannuation.fund',
  SUPER_FUND_MEMBER: 'superannuation.fundMember',
  SUPER_SELF_MANAGED_FORM: 'superannuation.selfManagedForm',
  SUPER_SMSF_FUND_ABN: 'superannuation.smsf.fundAbn',
  SUPER_SMSF_FUND_NAME: 'superannuation.smsf.fundName',
  SUPER_SMSF_MEMBER_NUMBER: 'superannuation.smsf.memberNumber',
  SUPER_SMSF_MEMBER_NAME: 'superannuation.smsf.memberName',
  SUPER_SMSF_ELECTRONIC_SERVICE_ADDRESS:
    'superannuation.smsf.electronicServiceAddress',
  SUPER_SMSF_BANK_ACCOUNT_NUMBER: 'superannuation.smsf.bankAccountNumber',
  SUPER_SMSF_BANK_ACCOUNT_NAME: 'superannuation.smsf.bankAccountName',
  SUPER_SMSF_BANK_ACCOUNT_BSB: 'superannuation.smsf.bankAccountBsb',
  SUPER_DECLARE_TRUE_AND_CORRECT: 'superannuation.declareTrueAndCorrect',
  TFN_OPTION: 'tfnDeclaration.option',
  TFN_NUMBER: 'tfnDeclaration.number',
  TFN_REASON: 'tfnDeclaration.reason',
  TFN_PERSONAL_TITLE: 'tfnDeclaration.personalDetails.title',
  TFN_PERSONAL_FULL_NAME: 'tfnDeclaration.personalDetails.FullName',
  TFN_TAX_PAY_BASIS: 'tfnDeclaration.taxDetails.payBasis',
  TFN_TAX_RESIDENT_STATUS: 'tfnDeclaration.taxDetails.residentStatus',
  TFN_TAX_COUNTRY_OF_ORIGIN: 'tfnDeclaration.taxDetails.countryOfOrigin',
  TFN_TAX_FREE_THRESHOLD: 'tfnDeclaration.taxDetails.taxFreeThreshold',
  TFN_TAX_HAS_LOAN_OR_STUDENT_DEBT:
    'tfnDeclaration.taxDetails.hasLoanOrStudentDebt',
  TFN_TAX_DECLARE_TRUE_AND_CORRECT:
    'tfnDeclaration.taxDetails.declareTrueAndCorrect',
};

// Superannuation progress state keys
export const SUPER_PROGRESS_STATE_KEYS = {
  COMPLETED: 'completed',
  COMPLETE: 'complete',
};

// TFN declaration outcome keys
export const TFN_OUTCOME_KEYS = {
  COMPLETE: 'complete',
  COMPLETE_UNSUCCESSFUL: 'complete_unsuccessful',
  INCOMPLETE: 'incomplete',
};

// Superannuation type keys
export const SUPER_TYPE_KEYS = {
  SELF_MANAGED: 'selfManaged',
  EMPLOYER_NOMINATED: 'employerNominated',
  EMPLOYEE_NOMINATED: 'employeeNominated',
};

// SMSF form upload statuses
export const SUPER_SELF_MANAGED_FORM_UPLOAD_STATUSES = {
  UPLOADED: 'Uploaded',
  NOT_UPLOADED: 'Not provided',
};

// Declaration statuses
export const DECLARE_TRUE_AND_CORRECT_STATUSES = {
  CHECKED: 'Checked',
  NOT_CHECKED: 'Not checked',
};

export const SUPER_TYPE_LABEL_MAP = {
  [SUPER_TYPE_KEYS.SELF_MANAGED]:
    'I have my own self-managed super fund (SMSF)',
  [SUPER_TYPE_KEYS.EMPLOYER_NOMINATED]: 'Superfund nominated by the employer',
  [SUPER_TYPE_KEYS.EMPLOYEE_NOMINATED]: 'My own choice of superannuation fund',
};

export const YES_NO_LABEL_MAP = {
  Yes: 'Yes',
  No: 'No',
  yes: 'Yes',
  no: 'No',
};

export const TITLE_MAP = {
  mr: 'Mr',
  mrs: 'Mrs',
  miss: 'Miss',
  ms: 'Ms',
  dr: 'Dr',
  other: 'Other',
};

export const TFN_EXEMPTION_LABEL_MAP = {
  notLodgedApplication: "I haven't lodged a TFN application",
  pendingApplication: "I have lodged but it's pending",
  under18AndNotEarningEnough:
    'I am under 18 years & not earning enough to pay tax',
  receivingPensionOrBenefitOrAllowance:
    'I am receiving a pension, benefit or allowance',
};

export const PAY_BASIS_LABEL_MAP = {
  'full-time': 'Full time',
  'part-time': 'Part time',
  casual: 'Casual',
  labourhire: 'Labour hire',
  'non-employee': 'Non employee',
};

export const RESIDENCY_LABEL_MAP = {
  resident: 'An Australian resident for tax purposes',
  'working-holiday': 'A working holiday maker',
  foreign: 'A foreign resident for tax purposes',
};

// Internal value maps for converting SuperAPI data
export const PAY_BASIS_MAP = {
  full_time: 'full-time',
  part_time: 'part-time',
  casual: 'casual',
  labour_hire: 'labourhire',
  non_employee: 'non-employee',
};

export const RESIDENCY_MAP = {
  australian_resident_for_tax_purposes: 'resident',
  working_holiday_maker: 'working-holiday',
  foreign_resident: 'foreign',
};

export const TAX_FREE_THRESHOLD_MAP = {
  true: 'yes',
  false: 'no',
};

export const HAS_LOAN_OR_STUDENT_DEBT_MAP = {
  true: 'yes',
  false: 'no',
};

export const U18_NOT_ELIGIBLE_LABEL =
  'No, under 18 and working less than 30 hours per week';

export const TFN_EXEMPTION_MAP = {
  not_quoted: 'notLodgedApplication',
  pending: 'pendingApplication',
  under_eighteen: 'under18AndNotEarningEnough',
  pensioner: 'receivingPensionOrBenefitOrAllowance',
};
